import type { CaseFieldValue } from "@/features/catalog_case_review/shared/model/caseReview";
import { caseFieldDisplayValue } from "@/features/catalog_case_review/shared/utils/caseFieldDisplayValue";
import { isCodingField } from "@/features/meddra/shared/model/meddraCoding";
import { savedMeddraCodingText } from "@/features/meddra/shared/model/savedMeddraCoding";
import type { FollowupProposalView } from "../types/followupReviewView";

/** A follow-up value as the reviewer reads it: a MedDRA coding by its term and code, never its stored record. */
export function followupValueText(proposal: FollowupProposalView, value: CaseFieldValue): string {
  const present = value !== null && value !== "";
  if (present && isCodingField(proposal.location.fieldId))
    return savedMeddraCodingText(value, proposal.location.fieldId);
  return caseFieldDisplayValue(value, proposal.kind, proposal.options);
}
